import React, { useEffect } from 'react';
import useIdle from '../../hooks/useIdle';
import { useUserState } from '../../hooks/context/useUserState';
import { isTimeExpired } from '../../utils/helpers';
import { useLogout } from '../../api/hooks/useLogout';
import { useCfgParam } from '../../hooks/useCfgParam';
import useApiErrorHandling from '../../hooks/useApiErrorHandling';
import Loading from '../Loading/Loading';
import { useTranslate } from '../../hooks/context/useTranslate';
import { SET_AUTOLOGOUT_PENDING } from '../../constants';

const AutoLogout: React.FC = () => {
  const {
    state: { loggedInAt, lastActivityTime, keepLoggedIn },
    dispatch,
  } = useUserState();
  const { logout, isPending } = useLogout();
  const autoLogout = useCfgParam('loginOptions', 'autoLogout');
  const timeoutSeconds = autoLogout * 1000;
  const isIdle = useIdle(timeoutSeconds);
  const permanentLoginDuration = useCfgParam(
    'loginOptions',
    'permanentLoginDuration'
  );
  const handleApiError = useApiErrorHandling();
  const { t } = useTranslate();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (e) {
      handleApiError(e);
    }
  };

  useEffect(() => {
    if (
      !keepLoggedIn &&
      lastActivityTime &&
      isTimeExpired(lastActivityTime, timeoutSeconds)
    ) {
      handleLogout();
    }
  }, []);

  useEffect(() => {
    dispatch({ type: SET_AUTOLOGOUT_PENDING, payload: isPending });
  }, [isPending]);

  useEffect(() => {
    if (keepLoggedIn) {
      const checkLoginTimeout = setInterval(() => {
        const dayInMiliseconds = 24 * 60 * 60 * 1000;
        const isPermenentLoginExpired = isTimeExpired(
          loggedInAt,
          permanentLoginDuration * dayInMiliseconds
        );

        if (isPermenentLoginExpired && navigator.onLine) {
          handleLogout();
        }
      }, 1000);
      return () => clearInterval(checkLoginTimeout);
    }
    if (isIdle && navigator.onLine && !keepLoggedIn) {
      handleLogout();
    }
  }, [keepLoggedIn, isIdle]);

  return <>{isPending && <Loading message={t('loggingOut')} />}</>;
};

export default AutoLogout;
